export default "__VITE_ASSET__D48iW9Jw__"